import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { CountryData, PaginatedData } from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

type UseGetCountries<T> = {
  noAuth?: boolean
  select?: (data: PaginatedData<CountryData[]>) => T
}

export const useGetCountries = <T>({ noAuth, select }: UseGetCountries<T>) =>
  useQuery({
    queryFn: () => api.countries.getCountries({ noAuth }),
    queryKey: queriesKeys.countries.getCountries(noAuth),
    refetchOnWindowFocus: false,
    select,
  })
